import { getApi } from "@beeldit/core/helpers/api";

async function index(endpoint: string, filterPath: string = "", config: any = null) {
  return await getApi().get(`/${endpoint}?${filterPath}`, config);
}

export default index;
